// SSO handoff pages opened by the desktop/mobile clients (SCRUM-1955): their URL carries the loopback
// `redirect_uri` and, on the Discord callback, the OAuth `code`/`state`, so no tracker may see it.
// The trailing slash keeps a future `/authors` out.
const TRACKING_EXEMPT_PREFIXES = ['/auth/'];

/**
 * Whether `_app` must leave every tracker off on this route. Takes `router.pathname`, which never carries
 * the locale prefix (`/pt/auth/mobile` arrives as `/auth/mobile`).
 */
export function isTrackingExemptRoute(pathname: string | undefined): boolean {
  if (!pathname) return false;
  // Bare `/auth` too: next.config's `/auth/:path*` matches it (`:path*` allows zero segments), and both
  // policies must cover the same routes.
  return pathname === '/auth' || TRACKING_EXEMPT_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
